import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';

import { sortOptionType, projectType } from 'types';
// eslint-disable-next-line import/no-named-as-default
import Search from 'components/Search';
import SortingMenu from 'components/SortingMenu';
import ProjectsSwitch from './components/ProjectsSwitch';

import './style.scss';

export default class ProjectsOptions extends Component {
  static propTypes = {
    getProjects: PropTypes.func,
    isGrid: PropTypes.bool,
    options: PropTypes.arrayOf(sortOptionType),
    projects: PropTypes.arrayOf(projectType),
    searchTerm: PropTypes.string,
    selectedSortOption: sortOptionType,
    toggleGridView: PropTypes.func,
  };

  /* eslint-disable react/destructuring-assignment */
  shouldComponentUpdate({ searchTerm, selectedSortOption, isGrid, projects }) {
    return (
      searchTerm !== this.props.searchTerm ||
      !_isEqual(selectedSortOption, this.props.selectedSortOption) ||
      isGrid !== this.props.isGrid ||
      projects.length !== this.props.projects.length
    );
  }

  searchProjects = searchTerm => {
    this.props.getProjects({
      page: 1,
      name__icontains: searchTerm,
    });
  };

  render() {
    const {
      options,
      selectedSortOption,
      isGrid,
      projects,
      getProjects,
      toggleGridView,
    } = this.props;

    return (
      <div styleName="options">
        <Search getItems={this.searchProjects} itemsCount={projects.length} />

        <SortingMenu
          getItems={getProjects}
          items={projects}
          options={options}
          selectedSortOption={selectedSortOption}
          styleName="sorting-menu"
        />

        <ProjectsSwitch
          isGrid={isGrid}
          projects={projects}
          toggleGridView={toggleGridView}
        />
      </div>
    );
  }
}
